import { ref } from "vue";

import { defineStore } from "pinia";

import externalApiService from "@/services/external";

import type { DealStip } from "@/models/stips";

const useServicingStore = defineStore("servicing", () => {
  const offerId = ref("");
  const requiredStips = ref<DealStip[]>([]);
  const uploadedFiles = ref<Record<string, File[]>>({});

  const addUploadedFile = (payload: { section: number; file: File }) => {
    const tempFiles = { ...uploadedFiles.value };
    tempFiles[payload.section].push(payload.file);
    uploadedFiles.value = tempFiles;
  };

  const getRequiredStips = async () => {
    const data = await externalApiService.getRequiredStipsForOffer(
      offerId.value
    );
    requiredStips.value = data;
    uploadedFiles.value = Object.values(requiredStips.value).reduce(
      (acc, curr) => ({ ...acc, [curr.id]: [] }),
      {}
    );
  };

  const removeFile = async (payload: {
    index: number;
    section: number;
    fileId: number;
  }) => {
    await externalApiService.removeUploadedFile({
      ...payload,
      offerId: offerId.value,
    });
    const tempFiles = { ...uploadedFiles.value };
    tempFiles[payload.section].splice(payload.index, 1);
    uploadedFiles.value = tempFiles;
  };

  return {
    offerId,
    requiredStips,
    uploadedFiles,
    addUploadedFile,
    getRequiredStips,
    removeFile,
  };
});

export default useServicingStore;
